"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default2 = {
  name: 'CustomerInfo',
  props: {
    customerInfo: {
      type: Object,
      default: function _default() {
        return {
          contactPerson: '',
          contactNumber: '',
          contactAddress: '',
          coordinate: ''
        };
      }
    }
  }
};
exports.default = _default2;